import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import actions from './actions';

export function* createUser() {
    yield takeEvery(actions.CREATE_USER_REQUESTED, function* (action) {
        try {
            const user = yield call(actions.createOrUpdateUser, action.payload);
            yield put({ type: actions.CREATE_USER_SUCCEEDED, user });
        } catch (error) {
            yield put({ type: actions.CREATE_USER_FAILED, error: error.response.data.message });
        }
    });
}

export function* blockUser() {
    yield takeEvery(actions.BLOCK_USER_REQUESTED, function* (action) {
        try {
            const user = yield call(actions.createOrUpdateUser, action.payload);
            yield put({ type: actions.BLOCK_USER_SUCCEEDED, user });
        } catch (error) {
            yield put({ type: actions.BLOCK_USER_FAILED, error: error.response.data.message });
        }
    });
}

export function* unBlockUser() {
    yield takeEvery(actions.UNBLOCK_USER_REQUESTED, function* (action) {
        try {
            const user = yield call(actions.createOrUpdateUser, action.payload);
            yield put({ type: actions.UNBLOCK_USER_SUCCEEDED, user });
        } catch (error) {
            yield put({ type: actions.UNBLOCK_USER_FAILED, error: error.response.data.message });
        }
    });
}

export default function* rootSaga() {
  yield all([
    fork(createUser),
    fork(blockUser),
    fork(unBlockUser),
  ]);
}
